import React, { useState } from 'react'
import './ChooesACategory.scss'
import Image from '../../img/BigOnBreakfast.svg'
import Arrow from '../../img/Arrow.svg'
import { Link } from 'react-router-dom'

const ChooesACategory = ({data}) => {
   
  return (
    <div className='allCategory'>
         {data && data.map((category) => {
            return(
                <div className='category'>
                    <div style={{backgroundImage:`url(${category.ImageURL})`,backgroundSize:"cover",backgroundRepeat:"no-repeat"}}></div>
                     {/* <img width={180} height={125} src={Image} alt='img'/> */}
                     <span className='categoryItem'>
                              <span className='itemName'>{category.Name}</span>
                              {category.OpenTime !== '' && (
                              <span className='openedTime'>
                                <span className='openedTime-1'>{category.OpenTime}</span>
                              </span>
                              )}
                              <Link to={`/Category/${category.Name}`}>
                              <span className='Arrow'><img loading='lazy' width={30} src={Arrow} alt={`View for ${category.Name}`} /></span>

                              </Link>
                     </span>

                     
                </div>
            )
         })}


         
    </div>
  )
}

export default ChooesACategory
